import { Component, OnInit, ViewChild, Input, OnChanges } from '@angular/core';
import { StatsService } from '../../stats.service';
import { isNil } from 'ramda/es';
import { TranslateService } from '@ngx-translate/core';
import { tap, first } from 'rxjs/operators';
@Component({
  selector: 'app-table-chart',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableChartComponent implements OnInit, OnChanges {
  @Input() sessionId: any;
  @Input() url: Function;
  public rows: any[] = [];
  containsData = false;
  public columns: any[] = [];
  public page = 1;
  public itemsPerPage = 5;
  public maxSize = 5;
  public numPages = 1;
  public length = 0;
  public config = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };
  private data: any[] = [];
  constructor(private statsService: StatsService, private translate: TranslateService) {}

  ngOnChanges() {
    this.initTable();
  }
  initTable() {
    const source$ = this.statsService.call(`${this.url(this.sessionId)}`);
    const onData$ = tap((data: any) => {
      this.containsData = data.length > 0;
      this.data = data;
      this.onChangeTable(this.config);
    });

    source$
      .pipe(
        first(),
        onData$
      )
      .subscribe();
  }
  ngOnInit() {
    this.initTable();
    this.translate
      .get([
        'stats.table.login',
        'stats.table.filter_name',
        'stats.table.email',
        'stats.table.filter_email',
        'stats.table.first_connection',
        'stats.table.last_action',
        'stats.table.connection_length',
        'stats.table.hits'
      ])
      .subscribe(translationKeys => {
        this.columns = [
          {
            title: this.translate.instant(translationKeys['stats.table.login']),
            name: 'nickName',
            filtering: {
              filterString: '',
              placeholder: this.translate.instant(translationKeys['stats.table.filter_name'])
            }
          },
          {
            title: this.translate.instant(translationKeys['stats.table.email']),
            name: 'email',
            filtering: {
              filterString: '',
              placeholder: this.translate.instant(translationKeys['stats.table.filter_email'])
            }
          },
          {
            title: this.translate.instant(translationKeys['stats.table.first_connection']),
            name: 'first_connection_date'
          },
          {
            title: this.translate.instant(translationKeys['stats.table.last_action']),
            name: 'last_action_date'
          },
          {
            title: this.translate.instant(translationKeys['stats.table.connection_length']),
            name: 'connection_minutes'
          },
          { title: this.translate.instant(translationKeys['stats.table.hits']), name: 'hits' }
        ];
      });
  }

  public changePage(page: any, data: any[] = this.data): any[] {
    const start = (page.page - 1) * page.itemsPerPage;
    const end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    const columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;
    columns.forEach(column => {
      if (column.sort !== '' && column.sort !== false) {
        columnName = column.name;
        sort = column.sort;
      }
    });

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      }
      if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: any[] = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString)
      );
    }

    const tempArray: any[] = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (!isNil(item[column.name])) {
          if (item[column.name].toString().match(this.config.filtering.filterString)) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    const filteredData = this.changeFilter(this.data, this.config);
    const sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  public onCellClick(data: any): any {}
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/table/table.component.ts